import { useRouter } from "next/router";
import { useMemo } from "react";
import { Icon, ImageLite, PageLink, Paragraph } from "shared/components";
import { formatDate } from "shared/utils";

import styles from "./Item.module.scss";

export const Item = ({
  title,
  slug,
  date: articleDate,
  eventDate,
  previewImage,
  contentType,
}) => {
  const { locale } = useRouter();
  const itemDate = useMemo(
    () => (contentType === "event" ? eventDate : articleDate),
    [contentType, eventDate, articleDate]
  );

  const date = useMemo(() => {
    return formatDate(itemDate, locale);
  }, [locale, itemDate]);

  const directoryLink = useMemo(() => {
    return contentType === "event" ? "events" : "news";
  }, [contentType]);

  return (
    <PageLink directory={directoryLink} slug={slug} className={styles.wrapper}>
      <div className={styles.content}>
        <ImageLite image={previewImage} className={styles.image} />
        <span className={styles.arrow}>
          <Icon className={styles.icon} name="arrow_right" />
        </span>
        <Paragraph className={styles.date} color="grey" uppercase>
          {date}
        </Paragraph>
        <Paragraph className={styles.title} color="dark">
          {title}
        </Paragraph>
      </div>
    </PageLink>
  );
};
